export const config = {
    apiKey: "AIzaSyAB4it6LWh6JNp7Ys64hV6yqNCyyyziiJs",
    appId: "1:901527757245:web:3fbde8014148f434",
    clientId:
        "901527757245-od08i1g82f89ii0ggt2gv2566vmra7fu.apps.googleusercontent.com",
    spreadsheetId: "1GhK5VhT--_wiY4rT2wW03uvQGE4i1O-sc57hMR9lhHo",
    discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
    scopes: "https://www.googleapis.com/auth/spreadsheets"
}
